import {
    CodeBlock, BlockType, SettingType, ValidationMessage, SettingState,
} from '@appblocks/codegeneration/types';

import BaseFeature from '@appblocks/codegeneration/BaseFeature';

export default class Commands extends BaseFeature {
    constructor() {
        super();
        this.name = 'Commands';
        this.id = 'commands';
        this.icon = 'FaPlay';
        const settings = [
            {
                id: 'COMMANDS',
                name: 'Commands',
                settingType: SettingType.ARRAY,
                required: true,
                refId: 'command',
                default: new Array<BaseFeature>(0),
                helpText: 'Commands are used in blocks to trigger events.',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getEnabled(): boolean {
        const COMMANDS = this.getSettingValue('COMMANDS');
        return COMMANDS.length > 0;
    }

    getCodeBlocks() {
        let blocks: Array<CodeBlock> = [];

        const COMMANDS = this.getSettingValue('COMMANDS');
        for (let i = 0; i < COMMANDS.length; i++) {
            blocks = blocks.concat(COMMANDS[i].getCodeBlocks());
        }

        return blocks;
    }

    getDetails(): string {
        return `
## Commands
Commands provides a way for functions on the device to be triggered.

Commands can come from the cloud, the device itself, or from dashboards.

Commands can be used with the **On Command** and **Execute Command** blocks

![commands blocks](/static/img/blocks_commands.png)

        `;
    }
}
